// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Image edit prompt: one visual for keyframe + org-asset; parent pages only set outer padding. */

/* Keyframe + fullscreen: match width / centering */
.prompt-box.image-edit-prompt-box--constrained {
  max-width: 900px;
  margin: 0 auto;
}

.prompt-box.image-edit-prompt-box .prompt-box-form {
  max-width: none;
  width: 100%;
  gap: 4px;
}

.prompt-box.image-edit-prompt-box .prompt-box-textarea {
  min-height: 36px;
  max-height: 160px;
}

/* Same chrome as default PromptBox (bordered field) — do not add alternate “card” styles in page CSS. */

/* Upload + model + submit: one 32px row */
.prompt-box.image-edit-prompt-box .model-selector.model-selector--compact .model-selector-trigger {
  height: 32px;
  padding: 0 10px;
  box-sizing: border-box;
}

.prompt-box.image-edit-prompt-box .model-selector.model-selector--compact .model-selector-icon {
  width: 14px;
  height: 14px;
}

.prompt-box.image-edit-prompt-box .prompt-box-action-button,
.prompt-box.image-edit-prompt-box .prompt-box-submit-button {
  width: 32px;
  height: 32px;
  box-sizing: border-box;
}

.prompt-box.image-edit-prompt-box .prompt-box-uploaded-item {
  border-radius: 8px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
}

.prompt-box.image-edit-prompt-box .prompt-box-mention-dropdown {
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}

.prompt-box.image-edit-prompt-box .prompt-box-mention-item.selected,
.prompt-box.image-edit-prompt-box .prompt-box-mention-item:hover {
  background: var(--color-bg-user-bubble);
}
`, "",{"version":3,"sources":["webpack://./src/components/editor/ImageEditPromptBox.css"],"names":[],"mappings":"AAAA,iGAAiG;;AAEjG,mDAAmD;AACnD;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wGAAwG;;AAExG,0CAA0C;AAC1C;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE,uCAAuC;AACzC","sourcesContent":["/* Image edit prompt: one visual for keyframe + org-asset; parent pages only set outer padding. */\r\n\r\n/* Keyframe + fullscreen: match width / centering */\r\n.prompt-box.image-edit-prompt-box--constrained {\r\n  max-width: 900px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.prompt-box.image-edit-prompt-box .prompt-box-form {\r\n  max-width: none;\r\n  width: 100%;\r\n  gap: 4px;\r\n}\r\n\r\n.prompt-box.image-edit-prompt-box .prompt-box-textarea {\r\n  min-height: 36px;\r\n  max-height: 160px;\r\n}\r\n\r\n/* Same chrome as default PromptBox (bordered field) — do not add alternate “card” styles in page CSS. */\r\n\r\n/* Upload + model + submit: one 32px row */\r\n.prompt-box.image-edit-prompt-box .model-selector.model-selector--compact .model-selector-trigger {\r\n  height: 32px;\r\n  padding: 0 10px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.prompt-box.image-edit-prompt-box .model-selector.model-selector--compact .model-selector-icon {\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n.prompt-box.image-edit-prompt-box .prompt-box-action-button,\r\n.prompt-box.image-edit-prompt-box .prompt-box-submit-button {\r\n  width: 32px;\r\n  height: 32px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.prompt-box.image-edit-prompt-box .prompt-box-uploaded-item {\r\n  border-radius: 8px;\r\n  background: var(--color-bg-input);\r\n  border: 1px solid var(--color-border-input);\r\n}\r\n\r\n.prompt-box.image-edit-prompt-box .prompt-box-mention-dropdown {\r\n  background: var(--color-bg-canvas-surface);\r\n  border: 1px solid var(--color-border-input);\r\n  border-radius: 8px;\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.prompt-box.image-edit-prompt-box .prompt-box-mention-item.selected,\r\n.prompt-box.image-edit-prompt-box .prompt-box-mention-item:hover {\r\n  background: var(--color-bg-user-bubble);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
